import type { DebtOrderItem } from '@/lib/api/customer-api'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover'
import { formatQty } from '@/lib/format'

const MAX_VISIBLE = 3

// "Tên sản phẩm (số lượng)"
function label(it: DebtOrderItem) {
    return `${it.product_name} (${formatQty(it.quantity)})`
}

// Danh sách SP của đơn: hiện tối đa 3, phần dư gom vào tag "+N"; bấm tag mở
// popover neo vào tag liệt kê các SP đã ẩn.
export function ProductListCell({ items }: { items?: DebtOrderItem[] }) {
    const list = items ?? []
    if (list.length === 0) {
        return <span className="text-muted-foreground">—</span>
    }
    const visible = list.slice(0, MAX_VISIBLE)
    const hidden = list.slice(MAX_VISIBLE)

    return (
        <div className="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-sm">
            {visible.map((it, i) => (
                <span key={i}>
                    {label(it)}
                    {i < visible.length - 1 || hidden.length > 0 ? ',' : ''}
                </span>
            ))}
            {hidden.length > 0 && (
                <Popover>
                    <PopoverTrigger asChild>
                        <button
                            type="button"
                            className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground hover:bg-muted/70"
                        >
                            +{hidden.length}
                        </button>
                    </PopoverTrigger>
                    <PopoverContent align="start" className="w-64 p-2">
                        <ul className="space-y-1 text-sm">
                            {hidden.map((it, i) => (
                                <li key={i}>{label(it)}</li>
                            ))}
                        </ul>
                    </PopoverContent>
                </Popover>
            )}
        </div>
    )
}
